module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Image *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('image-uploader', {
    ref: "uploader",
    attrs: {
      "uploaded-img-url": _vm.entity.puzzle.public_url,
      "removable": false
    },
    on: {
      "changeFile": _vm.coverChange
    }
  })], 1)]), _vm._v(" "), (_vm.imageLoaded) ? [_vm._l((_vm.presets), function(preset) {
    return _c('div', {
      key: preset.id,
      staticClass: "form-group row"
    }, [_c('label', {
      staticClass: "col-md-2",
      attrs: {
        "for": preset.type
      }
    }, [_vm._v(_vm._s(preset.title) + " *")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-10"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.entity.levels[preset.type]),
        expression: "entity.levels[preset.type]"
      }],
      staticClass: "form-control",
      attrs: {
        "id": ((preset.type) + "*")
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.entity.levels, preset.type, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.makeOptions(preset)), function(item, key) {
      return _c('option', {
        key: key,
        domProps: {
          "value": item
        }
      }, [_vm._v("\n                        " + _vm._s(item.text) + "\n                      ")])
    }), 0)])])
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "default"
    }
  }, [_vm._v("Default *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.default_level),
      expression: "entity.default_level"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "default"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "default_level", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.presets), function(preset, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": preset.type
      }
    }, [_vm._v("\n                        " + _vm._s(preset.title) + "\n                      ")])
  }), 0)])])] : _vm._e(), _vm._v(" "), _vm._l((_vm.entity.quotes), function(quote, key) {
    return [_c('PuzzleQuote', {
      key: key,
      attrs: {
        "quote": quote,
        "number": key
      },
      on: {
        "deleteQuote": _vm.onDeleteQuote
      }
    })]
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.addQuote
    }
  }, [_vm._v("\n                Add Quote\n              ")])], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Puzzle image has added successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Edit puzzle image")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c453e5a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/games/puzzles/Edit.vue
// module id = 891
// module chunks = 0